/* eslint-disable */
var $ = window.jQuery = require('jquery');

import TabDetails from '../course-tab-details/index';
import bulletsPoint from '../tab-bullets-point/index';
import {
  bus
} from '@/main';
import draggable from "vuedraggable";
import {
  mapGetters
} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'course-details',
  components: {
    'course-tab-details': TabDetails,
    'bullets-point': bulletsPoint,
    draggable
  },
  props: [],
  data() {
    return {
      name: 'Other',
      content: '',
      course: '',
      courseDetais:null,
      submitted: false,
      editcourseTabDetails: false,
      tabId: '',
      courseTabId: '',
      BulletsListEnabled: false,
      deleteTABID: '',
      isActive: false,
      is_active: false,
      selectedTabID: '',
      courseId: ''
    }
  },
  computed: {
    ...mapGetters([
      'getsectionbycourseIDState'
    ]),
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        ghostClass: "ghost"
      };
    },
    getCourseDetails() {
      this.courseDetais = this.$store.getters.getsectionbycourseIDState.data;
      return
    },
  },
  mounted() {
    this.courseId = this.$route.params.id;
    this.getCourseDetails
    bus.$on('hideEditTabDetailsPopup', (data) => {
      this.editcourseTabDetails = data;
    });
  },
  methods: {
    courseTabStatusAct(tabId) {
      let data = {
        id: tabId
      }
      this.$store.dispatch('getCourseTabDetailsByID', data)
        .then((res) => {
          if (res.data.code == '2000') {
            this.isActive = this.$store.getters.getcourseDetailstabByIDState.data.data.is_active
            if (this.isActive === true) {
              this.is_active = false
            }
            if (this.isActive === false) {
              this.is_active = true
            }
            let data = {
              is_active: this.is_active,
            }
            this.$store.dispatch('updateCourseTabDetailsByID', {
              data: {
                data: data,
                id: tabId
              }
            }).then((res) => {
              if (res.status == '200') {
                this.getCourseDetailsAgain();
                toast.success("Course Tab Status Updated Successfully");
              }
            }).catch((err) => {})
            return
          }
        }).catch((err) => {})
    },
    getCourseDetailsAgain() {
      this.$store.dispatch('sectionbycourseId', {
        id: this.$route.params.id,
        tab_name:'details'
      }).then((res) => {
        console.log(res.data)
      }).catch((err) => {})
    },
    validateCreateTabBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            name: this.name,
            content: this.content,
            course: this.courseDetais.id
          }
          this.$store.dispatch('course_details_tab', data).then((res) => {
              if (res.status == '201') {
                this.courseTabId = res.data.data.id;
                this.BulletsListEnabled = true;
                this.getCourseDetailsAgain();
                this.name = '',
                  this.content = '',
                  toast.success(res.data.msg);
                this.$validator.reset();
              }
            })
            .catch((err) => {})
          return
        }
      });
    },
    onChange(event) {
      this.name = event.target.value
      if (this.name == this.name && this.name !== 'Other') {
        $('#tabName').attr("disabled", true);
      } else if (this.name == 'Other') {
        // debugger
        $('#tabName').attr("disabled", false);
        $('#tabName').focus(function() {
          // debugger
          if ($(this).val() == 'Other') $(this).val("");
          console.log($(this).val())
        })
        // let default_value = this.name;
        // console.log(default_value , 'value')

      } else {
        // debugger
        $('#tabName').attr("disabled", false);
      }
      this.courseTabId = '';
      this.BulletsListEnabled = false;
    },
    valueBlank() {
      if ($('#tabName').val() == 'Other') {
        $('#tabName').val("");
      }
    },
    getTabListFun(id) {
      this.tabId = id
      this.editcourseTabDetails = true
      event.preventDefault
    },
    PopupClose() {
      this.editcourseTabDetails = false
    },
    removeTabagain(id) {
      $('#removeTabModal').modal();
      //$('body').addClass('removeOverlay');
      this.selectedTabID = id;
    },
    removeTabClose() {
      //$('body').removeClass('removeOverlay');
    },
    removeTabConfirmationagain() {
      let data = {
        id: this.selectedTabID
      }
      this.$store.dispatch('RemoveCourseTabByID', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            toast.success(res.data.msg);
            this.getCourseDetailsAgain();
            $('body').removeClass('removeOverlay');
          }
        })
        .catch((err) => {})
    },
    bulletSort: function(event) {
      if (event.moved && event.moved != undefined) {
        this.updateTabIndex(event.moved.element.id, Number(event.moved.newIndex) + 1);
      }
    },
    updateTabIndex(tabId, rowIndex) {
      let data = {
        index: rowIndex
      }
      this.$store.dispatch('UpdateTabIndex', {
          data: {
            data: data,
            id: tabId
          }
        })
        .then((res) => {
          toast.success(res.data.msg);
          this.getCourseDetailsAgain();
        })
        .catch((err) => {})
    }
  },
  beforeMount() {
    this.getCourseDetails;
  },
  watch: {
    getCourseDetails() {
      return this.$store.getters.getsectionbycourseIDState.data
    },
  }
}